import React, { useRef, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Card, Input } from "antd";
import ReactLoading from "react-loading";
import exportFromJSON from "export-from-json";
import { CopyToClipboard } from "react-copy-to-clipboard";
import QRCode from "qrcode.react";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";
import { useEffect } from "react";

function GenerateQrCode() {
  const [loader, setLoader] = useState(false);
  const [qrValue, setQrValue] = useState(null);
  const [canViewQrCode, setCanViewQrCode] = useState(false);
  const [canGenerateQrCode, setCanGenerateQrCode] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const [viewAllowed, generateAllowed] = await Promise.all([
        checkPermission(userRole, "generate_qr_code_module", "view_qr_code"),
        checkPermission(userRole, "generate_qr_code_module", "generate_qr_code"),
      ]);
      setCanViewQrCode(viewAllowed);
      setCanGenerateQrCode(generateAllowed);
    } catch (error) {
      console.error("Permission check failed for Generate QR Code Module:", error);
    }
  };

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  const downloadQRCode = () => {
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `QR_CODE.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  if (!canViewQrCode) {
    return <div></div>;
  }

  return (
    <>
      <Dashboard title="Generate XLSX">
        {loader && (
          <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
        )}
        <div className="row">
          <div className="col-12">
            <Card title="" className="border mt-3">
              <div className="row">
                <div className="col-md-12 mb-4">
                  <Input
                    type="text"
                    onChange={(e) => {
                      setQrValue(e.target.value);
                    }}
                    value={qrValue}
                    style={{
                      padding: "10px 11px",
                      fontSize: "16px",
                      lineHeight: 1.5,
                      borderRadius: "8px",
                    }}
                    allowClear
                    size="large"
                    placeholder={"Enter url"}
                  />
                </div>
                <div className="col-12">
                  <div className="card p-3 d-flex align-items-center justify-content-center flex-column gap-3">
                    <h1 className="my-2 text-[1.5rem]">QR-CODE</h1>
                    <QRCode
                      id="qr-gen"
                      value={qrValue}
                      size={300}
                      level="H"
                      bgColor="#ffffff"
                      fgColor="#111827"
                      includeMargin={true}
                      imageSettings={{
                        src: "/logo.png",
                        height: 60,
                        width: 60,
                        excavate: true,
                      }}
                    />
                    <h4 className="ml-1">
                      {canGenerateQrCode && (
                        <button
                          className="btn btn-primary ml-1"
                          onClick={downloadQRCode}
                        >
                          Download QR Code
                        </button>
                      )}
                    </h4>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Dashboard>
    </>
  );
}

export default GenerateQrCode;
